import React__default from 'react';
import { b as TouchLinkContent, c as TouchLinkIcon } from './TouchLink.styles-a07bd8eb.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-1702ffd3-fa72660f.js';

const TouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(TouchLinkContent, null, children, /*#__PURE__*/React__default.createElement(TouchLinkIcon, {
  type: angleInlineEnd,
  size: "lg"
}));
var TouchLinkBody$1 = TouchLinkBody;

export { TouchLinkBody$1 as T };
//# sourceMappingURL=TouchLinkBody-2121fd64.js.map
